import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import GapFillingSection from './components/GapFillingSection';
import ImpactSection from './components/ImpactSection';
import GetInvolvedSection from './components/GetInvolvedSection';
import GetHelpSection from './components/GetHelpSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <GapFillingSection />
      <ImpactSection />
      <GetInvolvedSection />
      <GetHelpSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
